import React from "react";
import "./RelatorioRupturaPrint.css";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../Config/firebase";
import { useEffect, useRef, useState } from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import { AMBIENTE_PRODUCAO, NOME_EMPRESA_LEGAL } from "../Config/branding";

function ehSlumpFlow(valor) {
  const numero = Number(String(valor ?? "").replace(",", "."));
  return Number.isFinite(numero) && numero > 300;
}

export default function RelatorioRupturaPrint({
  form,
  ensaios,
  calcularResistencia,
  obraId,
  listaMoldagens,
  moldagemId,   // 🔥 ADICIONE
  obraDados: obraDadosInformados = null,
  nomeEmpresaSaaS = "Empresa responsável",
  onVoltar,
  autoPrint = false,
}) {
  const [carregado, setCarregado] = useState(false);
  const jaImprimiuRef = useRef(false);

  function formatarDataBR(dataISO) {
    if (!dataISO) return "";
    const [ano, mes, dia] = dataISO.split("-");
    return `${dia}/${mes}/${ano}`;
  }

  function formatarPrensaClasseModelo(prensa) {
    if (!prensa?.id) {
      return "";
    }

    const classe = prensa.classe ? `Classe ${prensa.classe}` : "";
    const partes = [
      prensa.marca && `Marca ${prensa.marca}`,
      prensa.equipamento,
      prensa.modelo && `Modelo ${prensa.modelo}`,
      prensa.capacidade,
      prensa.serie && `Serie ${prensa.serie}`,
      prensa.tipo
    ].filter(Boolean);

    return [classe, partes.join(" - ")].filter(Boolean).join(", ");
  }

  function formatarPrensaCalibracao(prensa) {
    if (!prensa?.id) {
      return "";
    }

    const data = formatarDataBR(prensa.dataCalibracao || "");
    const certificado = prensa.certificado || prensa.codigo || "";
    const local = [
      prensa.empresa,
      prensa.cidade || prensa.local
    ].filter(Boolean).join(", ");

    return [
      data,
      certificado && `Certificado Nº ${certificado}`,
      local
    ].filter(Boolean).join(" - ");
  }

  function formatarDataExtenso(dataISO) {
  if (!dataISO) return "";

  const meses = [
    "janeiro", "fevereiro", "março", "abril", "maio", "junho",
    "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
  ];

  const [ano, mes, dia] = dataISO.split("-");
  return `${Number(dia)} de ${meses[Number(mes) - 1]}, ${ano}`;
}

  const idadesOriginais = Array.isArray(form.idades) ? form.idades : [];
const gruposDeIdades = dividirIdadesEmGrupos(idadesOriginais);

function dividirIdadesEmGrupos(idades = []) {
  const grupos = [];

  for (let i = 0; i < idades.length; i += 3) {
    grupos.push(idades.slice(i, i + 3));
  }

  // Se não houver nenhuma idade
  if (grupos.length === 0) {
    grupos.push([]);
  }

  return grupos;
}


 function mapearIdadesComIndice(grupo, grupoIndex) {
  const faltantes = 3 - grupo.length;

  const vazio = Array(faltantes).fill({ idade: null, indexReal: null });

  const preenchido = grupo.map((idade, i) => ({
    idade,
    indexReal: grupoIndex * 3 + i
  }));

  return [...vazio, ...preenchido];
}

  function somarDias(dataISO, dias) {
    if (!dataISO || !dias) return "-";
    const data = new Date(dataISO);
    data.setDate(data.getDate() + Number(dias));
    return data.toLocaleDateString("pt-BR");
  }

  function valorOuTraco(valor) {
    if (!valor && valor !== 0) return "-";
    return valor;
  }

  function formatarTipoLancamento(tipoLancamento) {
    if (tipoLancamento === "bombeado") return "BOMBEADO";
    if (tipoLancamento === "convencional") return "DESCARGA DIRETA";
    if (tipoLancamento === "nao_informado") return "N/I";
    return tipoLancamento || "";
  }

  function mpaOuTraco(valor) {
    if (!valor) return "-";
    return calcularResistencia(valor) || "-";
  }

function criadoEmMs(valor) {
  if (!valor) return 0;
  if (typeof valor.toMillis === "function") return valor.toMillis();
  if (typeof valor.seconds === "number") return valor.seconds * 1000;

  const data = new Date(valor);
  return Number.isNaN(data.getTime()) ? 0 : data.getTime();
}

function obterPrimeiraNotaFiscal(moldagem = {}) {
  const caminhoes = Array.isArray(moldagem.caminhoes)
    ? [...moldagem.caminhoes]
    : [];

  caminhoes.sort(
    (a, b) => Number(a?.cod_caminhao || 0) - Number(b?.cod_caminhao || 0)
  );

  const primeiraNota = caminhoes.find((caminhao) =>
    String(caminhao?.notaFiscalRomaneio || "").trim()
  )?.notaFiscalRomaneio;
  const numeroNota = Number(String(primeiraNota || "").replace(/\D/g, ""));

  return Number.isFinite(numeroNota) && numeroNota > 0
    ? numeroNota
    : Number.MAX_SAFE_INTEGER;
}

function ordenarMoldagensPorNumeracao(a, b) {
  const data = (a.datamoldagem || "").localeCompare(b.datamoldagem || "");
  if (data !== 0) return data;

  const nota = obterPrimeiraNotaFiscal(a) - obterPrimeiraNotaFiscal(b);
  if (nota !== 0) return nota;

  return criadoEmMs(a.criadoEm) - criadoEmMs(b.criadoEm);
}

const ensaiosOrdenados = [...ensaios].sort(
  (a, b) => (a?.cod_caminhao || 0) - (b?.cod_caminhao || 0)
);

const linhasPorPagina = 14;

const incluirObservacaoRelatorio =
  form.incluirObservacaoRelatorio === true &&
  String(form.observacaoRelatorio || "").trim() !== "";

const caminhoesPorPagina = incluirObservacaoRelatorio
  ? linhasPorPagina - 1
  : linhasPorPagina;
  const gruposDeEnsaios = [];

  function calcularCodigoPaginaGlobal(lista, obraId, moldagemId, paginaIndex, codigoInicial = 0) {
  if (!lista || !obraId || !moldagemId) return "-";

  const mesmaObra = lista
    .filter(m => m.obraId === obraId)
    .sort((a, b) =>
      ordenarMoldagensPorNumeracao(a, b)
    );

  let somaPaginas = Number(codigoInicial || 0);

  for (const m of mesmaObra) {
    const linhasDaPagina =
      m.incluirObservacaoRelatorio === true &&
      String(m.observacaoRelatorio || "").trim() !== ""
        ? 13
        : 14;
    const paginasPorGrupoDeIdades = Math.ceil(
      (Number(m.qtdCaminhoes) || 0) / linhasDaPagina
    );
    const quantidadeGruposDeIdades = Math.max(
      1,
      Math.ceil((Array.isArray(m.idades) ? m.idades.length : 0) / 3)
    );
    const paginas = paginasPorGrupoDeIdades * quantidadeGruposDeIdades;

    if (m.id === moldagemId) {
      return somaPaginas + paginaIndex + 1;
    }

    somaPaginas += paginas;
  }

  return "-";
}

function calcularCodigoCaminhaoGlobal(
  lista,
  obraId,
  moldagemId,
  indexCaminhao,
  codigoInicialCaminhao = 0
) {
  if (!lista || !obraId || !moldagemId) return "-";

  const mesmaObra = lista
    .filter(m => m.obraId === obraId)
    .sort((a, b) =>
      ordenarMoldagensPorNumeracao(a, b)
    );

  let soma = Number(codigoInicialCaminhao || 0);

  for (const m of mesmaObra) {
    const qtd = Number(m.qtdCaminhoes || 0);

    if (m.id === moldagemId) {
      return soma + indexCaminhao + 1;
    }

    soma += qtd;
  }

  return "-";
}

  for (let i = 0; i < ensaiosOrdenados.length; i += caminhoesPorPagina) {
  const pagina = ensaiosOrdenados.slice(i, i + caminhoesPorPagina);

    while (pagina.length < caminhoesPorPagina) {
      pagina.push(null);
    }

    if (incluirObservacaoRelatorio) {
      pagina.push({ tipoLinha: "observacaoRelatorio" });
    }

    gruposDeEnsaios.push(pagina);
  }

  if (gruposDeEnsaios.length === 0) {
    const paginaVazia = [];
    for (let i = 0; i < caminhoesPorPagina; i++) {
      paginaVazia.push(null);
    }
    if (incluirObservacaoRelatorio) {
      paginaVazia.push({ tipoLinha: "observacaoRelatorio" });
    }
    gruposDeEnsaios.push(paginaVazia);
  }

  const [obraDados, setObraDados] = useState(obraDadosInformados);

        useEffect(() => {
          async function buscarObra() {
            if (obraDadosInformados) {
              setObraDados(obraDadosInformados);
              setCarregado(true);
              return;
            }

            if (!obraId) {
              setCarregado(true);
              return;
            }

            const snap = await getDoc(doc(db, "obras", obraId));

            if (snap.exists()) {
              setObraDados({ id: snap.id, ...snap.data() });
            }

            setCarregado(true);
          }

          buscarObra();
        }, [obraId, obraDadosInformados]);

  useEffect(() => {
    if (!autoPrint || !carregado || jaImprimiuRef.current) return;

    jaImprimiuRef.current = true;
    const frame = window.requestAnimationFrame(() => {
      window.print();
    });

    return () => window.cancelAnimationFrame(frame);
  }, [autoPrint, carregado]);
  return (
  <div className="relatorio-print relatorio-ruptura-print">
    {onVoltar && (
      <div className="acoes-print">
        <button onClick={onVoltar} className="btn-voltar">Voltar</button>
        <button onClick={() => window.print()} className="btn-imprimir">Imprimir</button>
      </div>
    )}
    <div className="print-container">
      {gruposDeIdades.map((grupoIdades, grupoIndex) =>
  gruposDeEnsaios.map((ensaiosPagina, paginaIndex) => {
    const idadesPagina = mapearIdadesComIndice(grupoIdades, grupoIndex);
    const paginaRelatorioIndex =
      grupoIndex * gruposDeEnsaios.length + paginaIndex;
    

    function montarCodigoFormatado(numero, dataISO, apelidoObra) {
  if (!numero || !dataISO) return "-";

  const ano = dataISO.split("-")[0];

  return `RE-CP-${numero}-${ano}-${apelidoObra || ""}`;
}

    return (
      <div key={`${grupoIndex}-${paginaIndex}`} className="pagina">

         

            {/* ================= BLOCO 1 ================= */}
            <table className="tabela">
              <tbody>
                <tr>
                  <td rowSpan="3" style={{ width: 140 }}>
                    <LogoRelatorio
                      alt="Logo"
                      className="logo"
                     />
                  </td>

                  <td colSpan="5" rowSpan="3" className="titulo">
                    SISTEMA DE GESTÃO DA QUALIDADE
                    <br />
                    CONCRETO - ENSAIO DE COMPRESSÃO DE CORPOS DE PROVA
                    CILÍNDRICOS - ABNT NBR 5739
                  </td>

                  <td className="center" style={{ width: 170 }}>
                    RQ 2.2.11
                  </td>
                </tr>

                <tr>
                  <td className="center">REVISÃO 00</td>
                </tr>

                <tr>
                  <td className="center">20/08/2025</td>
                </tr>

                <tr>
                  <td
  colSpan="4"
  style={{
    textAlign: "left",
    borderLeft: "1px solid #000",
    borderRight: "none"
  }}
>
                    <strong>DATA:</strong>{" "}
                    {formatarDataBR(
                      new Date().toISOString().split("T")[0]
                    )}
                  </td>

                  <td
  colSpan="4"
  style={{
    textAlign: "right",
    borderLeft: "none"
  }}
>
                    <strong>CÓDIGO:</strong>{" "}
                    {montarCodigoFormatado(
                      calcularCodigoPaginaGlobal(
                        listaMoldagens,
                        obraId,
                        moldagemId,
                        paginaRelatorioIndex,
                        obraDados?.codigoInicial ?? 0
                      ),
                      form.datamoldagem,
                      obraDados?.nomeEtiqueta
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

           {/* ================= BLOCO 2 ================= */}
             <table className="tabela-bloco2">
  <tbody>
    <tr>
  <td className="label">CÓD:</td>
<td>
  {calcularCodigoPaginaGlobal(
    listaMoldagens,
    obraId,
    moldagemId,
    paginaRelatorioIndex,
    obraDados?.codigoInicial ?? 0
  )}
</td>
</tr>

    <tr>
      <td className="label">EMPRESA/CONTRATANTE:</td>
      <td>{form.cliente || "-"}</td>
    </tr>

    <tr>
      <td className="label">OBRA:</td>
      <td>{obraDados?.nome || form.obra || "-"}</td>
    </tr>
   
    <tr>
      <td className="label">ENDEREÇO:</td>
      <td>{obraDados?.endereco || "-"}</td>
    </tr>
  </tbody>
</table>
            {/* ================= BLOCO 3 ================= */}
            <table className="bloco3">
              <tbody>
                <tr>
                  <td colSpan="2" className="b3-header">
                    RECEBIMENTO DO CONCRETO NA OBRA E MOLDAGEM DOS CORPOS DE PROVA
                  </td>
                </tr>

                <tr>
                  <td colSpan="2" className="b3-sub">
                    RESPONSÁVEL PELA PRODUÇÃO:
                    <strong> {valorOuTraco(form.concreteira)}</strong>
                  </td>
                </tr>

                <tr>
                  <td colSpan="2" className="b3-moldagem">
                    MOLDAGEM DOS CORPOS DE PROVA
                  </td>
                </tr>

                <tr>
                  <td className="b3-col esquerda">
                    <div className="linha-checkbox">
                      <span className="check-box">
                        {form.responsavelMoldagem === "concreto_engenharia" ? "X" : ""}
                      </span>
                      REALIZADO PELO TÉCNICO DA {nomeEmpresaSaaS.toUpperCase()}
                    </div>

                    <div className="linha-moldador">
                        NOME DO MOLDADOR: 
                        <span className="valor-dinamico">
                          {form.responsavelMoldagem === "concreto_engenharia"
                            ? valorOuTraco(form.moldador)
                            : "-"}
                        </span>
                      </div>
                  </td>

                  <td className="b3-col direita">
                    <div className="linha-checkbox">
                      <span className="check-box">
                        {form.responsavelMoldagem === "construtora" ? "X" : ""}
                      </span>
                      REALIZADO PELO TÉCNICO DA CONSTRUTORA
                    </div>

                    <div className="linha-moldador">
                      NOME DO MOLDADOR:{" "}
                      <span className="valor-dinamico">
                        {form.responsavelMoldagem === "construtora"
                          ? valorOuTraco(form.moldador)
                          : "-"}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            {/* ================= BLOCO 4 ================= */}
            <table className="tabela">
              <tbody>
                <tr>
                  <td colSpan="6" className="secao">
                    INFORMAÇÕES RELACIONADAS AO CONCRETO
                  </td>
                </tr>

                <tr className="linha-titulos-concreto">
                  <td>NOME DO TRAÇO</td>
                  <td>FCK (MPa)</td>
                  <td>{ehSlumpFlow(form.slumpProjeto) ? "SLUMP FLOW (mm)" : "SLUMP TEST(mm)"}</td>
                  <td>TIPO/ÁREA DO CP</td>
                  <td>TIPO DO CONCRETO</td>
                  <td>TIPO DE CAPEAMENTO</td>
                </tr>

                <tr className="linha-valores-concreto">
                  <td>{valorOuTraco(form.nomeTraco)}</td>
                  <td>{valorOuTraco(form.fckProjeto)}</td>
                  <td>
                    {form.slumpProjeto
                      ? `${form.slumpProjeto} ± ${form.toleranciaSlumpProjeto}`
                      : "-"}
                  </td>
                  <td>{valorOuTraco(form.tipoAreaCp)}</td>
                  <td>{valorOuTraco(formatarTipoLancamento(form.tipoLancamento))}</td>
                  <td>{valorOuTraco(form.tipoCapeamento)}</td>
                </tr>
              </tbody>
            </table>

            {/* ================= BLOCO 5 ================= */}
            <table className="tabela tabela-bloco5">
              <colgroup>
                <col style={{ width: "4%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "5%" }} />
                <col style={{ width: "4%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "35%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th colSpan="4">
                    DATA DA MOLDAGEM
                    <br />
                    {formatarDataBR(form.datamoldagem)}
                  </th>

                  <th colSpan="3" className="secao" style={{ borderBottom: "none" }}>
  RESISTÊNCIA À COMPRESSÃO (MPa)
</th>

                  <th rowSpan="4">PEÇA CONCRETADA</th>
                  <th rowSpan="4">OBSERVAÇÕES</th>
                </tr>

                <tr>
                  <th rowSpan="3">Nº CP</th>
                  <th rowSpan="3">ROMANEIO Nº</th>
                  <th rowSpan="3">
                    {ehSlumpFlow(form.slumpProjeto) ? "SLUMP FLOW" : "SLUMP"}
                    <br />
                    mm
                  </th>
                  <th rowSpan="3">
                    VOL.
                    <br />
                    m³
                  </th>

                  <th colSpan="3" className="center" style={{ borderTop: "none" }}>
                      IDADE E DATA DO ENSAIO
                    </th>
                </tr>

                <tr>
                  {idadesPagina.map((item, i) => (
                    <th key={i}>
  {item.idade
    ? isNaN(Number((item.idade.dias || "").trim()))
      ? item.idade.dias
      : `${item.idade.dias} dias`
    : "-"}
</th>
                  ))}
                </tr>

                <tr>
                  {idadesPagina.map((item, i) => (
                      <th key={i}>
                        {item.indexReal !== null &&
 form.datasRuptura?.[item.indexReal]
  ? formatarDataBR(form.datasRuptura[item.indexReal])
  : "-"}
                      </th>
                    ))}
                </tr>
              </thead>

             <tbody>
  {ensaiosPagina.map((ensaio, index) => {
    if (ensaio?.tipoLinha === "observacaoRelatorio") {
      return (
        <tr key={`observacao-${paginaIndex}`} className="linha-observacao-relatorio">
          <td colSpan="9">
            <strong>OBSERVAÇÃO: </strong>
            {form.observacaoRelatorio}
          </td>
        </tr>
      );
    }

    const indexGlobal = paginaIndex * caminhoesPorPagina + index;

    return (
      <tr key={ensaio?.id || index}>
        <td>
          {ensaio
            ? calcularCodigoCaminhaoGlobal(
                listaMoldagens,
                obraId,
                moldagemId,
                indexGlobal,
                obraDados?.codigoInicialCaminhao
              )
            : "-"}
        </td>

        <td>
          {ensaio ? valorOuTraco(ensaio.notaFiscalRomaneio) : "-"}
        </td>

        <td>
          {ensaio ? valorOuTraco(ensaio.slumpObtido) : "-"}
        </td>

        <td>
          {ensaio?.qtd !== undefined && ensaio?.qtd !== null
            ? Number(ensaio.qtd).toFixed(1).replace(".", ",")
            : "-"}
        </td>

        {idadesPagina.map((item, idx) => (
         <td
  key={`${paginaIndex}-${index}-${idx}`}
  style={{
    verticalAlign: "middle",
    padding: 0 // 🔥 IMPORTANTE
  }}
>
            <div className="resultado-ruptura-duplo">
              <div>
                {ensaio && item.indexReal !== null
                  ? mpaOuTraco(ensaio.resultados?.[item.indexReal]?.cp1)
                  : "-"}
              </div>
              <div>
                {ensaio && item.indexReal !== null
                  ? mpaOuTraco(ensaio.resultados?.[item.indexReal]?.cp2)
                  : "-"}
              </div>
            </div>
          </td>
        ))}

        <td>
          <div className="celula-fixa col-peca">
            {ensaio
              ? valorOuTraco(ensaio.pecaConcretada?.replace(/\n/g, " "))
              : "-"}
          </div>
        </td>

        <td>
          <div className="celula-fixa col-obs">
            {ensaio
              ? valorOuTraco(ensaio.observacoes?.replace(/\n/g, " "))
              : "-"}
          </div>
        </td>
      </tr>
    );
  })}
</tbody>
            </table>

            {/* ================= BLOCO 6 ================= */}
            <table className="bloco-final bloco6">
              <tbody>
                <tr>
                  <td
                    style={{
                      width: "220px",
                      fontWeight: "bold"
                    }}
                  >
                    PRENSA - CLASSE/TIPO/MODELO:
                  </td>

                  <td>
                    {formatarPrensaClasseModelo(form.prensaRuptura)}
                  </td>
                </tr>

                <tr className="sem-linha-superior">
                  <td style={{ fontWeight: "bold" }}>
                    DATA DE CALIBRAÇÃO:
                  </td>

                  <td>
                    {formatarPrensaCalibracao(form.prensaRuptura)}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* ================= BLOCO 7 ================= */}
            <table className="bloco-final">
              <tbody>
                <tr>
                  <td
                    rowSpan="3"
                    style={{
                      width: "160px",
                      fontWeight: "bold",
                      verticalAlign: "top",
                      textAlign: "left"
                    }}
                  >
                    OBSERVAÇÕES:
                  </td>

                  <td>
                    Cura dos corpos de prova efetuada em
                    solução saturada de hidróxido de Cálcio
                    a (27 ± 2) °C
                  </td>
                </tr>

                <tr>
                  <td>
                    N/I: Não informado. N/A: Não aplicável
                  </td>
                </tr>

                <tr>
                  <td>
                    Os resultados apresentados se referem
                    somente aos itens ensaiados e de que não
                    é permitida a reprodução total do
                    relatório sem prévia autorização do
                    cliente. De forma alguma está autorizada
                    a reprodução parcial do relatório.
                  </td>
                </tr>
              </tbody>
            </table>

            {/* ================= BLOCO 8 ================= */}
            <table className="bloco-final">
              <tbody>
                <tr>
                  <td style={{ width: "60%" }}>
                    <strong>LOCAL E DATA:</strong> PALMAS,
                    {formatarDataExtenso(
                      new Date()
                        .toISOString()
                        .split("T")[0]
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
  <div
    style={{
      width: "260px",     // 🔥 controla a largura do bloco
      margin: "0 auto"    // centraliza dentro do TD
    }}
  >
    <img
      src="/Images/assinaturaLeal.png"
      alt="Assinatura"
      style={{
        height: "35px",
        objectFit: "contain",
        display: "block",
        margin: "0 auto -17px auto"
      }}
    />

    <div style={{ borderTop: "1px solid #000", margin: "2px 0" }} />

    José Carlos Lemes Leal
    <br />
    Eng. Civil Esp. CREA 203379/D - TO
  </div>
</td>
                </tr>
              </tbody>
            </table>

            {/* ================= RODAPÉ ================= */}
            <div className="rodape">
              {AMBIENTE_PRODUCAO ? (
                <>{NOME_EMPRESA_LEGAL}: End: Av. 17 - MORUMBY QD. QM-01 LT. 14, LUZIMANGUES, PORTO NACIONAL – TO CEL. (63) 98469 6099 E-mail: www.concretoengenharia.com</>
              ) : nomeEmpresaSaaS}
       </div>
       </div> 
        );
      })
    )}

    </div>
  </div>
);
}
